import createImageGalleryApi from './provider';
const REPORT_ENTITY_TYPE = 'reports';

let { get, add, update, remove } = createImageGalleryApi(REPORT_ENTITY_TYPE);

export { get, add, update, remove };